import { h, render } from 'preact';
import { Provider } from 'react-redux';
import { PATHS } from 'common/constants';
import store from 'common/store/store';
import translator from 'common/i18n';
import { getVideoDuration, getWatchProgressLabel } from 'common/helpers/videos';
import { checkIsIOS } from 'common/helpers/misc';
import VideoMetaData from 'common/components/videos/video-meta-data';
import Button from 'common/components/button';
export default class Season {
    constructor(container) {
        this.container = container;
        const duration = this.container.dataset.duration;
        const episodesLabel = this.container.dataset.episodeNumber ? translator.lookup('label.channel.episode-number', { number: this.container.dataset.episodeNumber }) : translator.lookup('label.video-trailer');
        const watchProgress = Number(localStorage.getItem(`video-progress-${this.container.dataset.id}`));
        const isIOS = checkIsIOS(window.navigator);
        const isRoadtrip = JSON.parse(this.container.dataset.isRoadtrip);

        render( (
            <Provider store={store}>
                <VideoMetaData
                    className='season-video-thumbnail'
                    duration={translator.lookup('label.channel.min', { minutes: getVideoDuration(duration) })}
                    episodes={episodesLabel}
                    watchProgress={watchProgress}/>
                
                <div className="season__cta-container">
                    <Button
                        href={`/${translator.language.toLowerCase()}${ isRoadtrip ? PATHS.videoRoadtrip : PATHS.video }${this.container.dataset.id}`}>{ getWatchProgressLabel( watchProgress, isIOS ) }</Button>
                </div>
            </Provider>
        ), this.container)
    }

    // Called when the widget is removed from the page
    destroy() {
        render( null, this.container );
    };
};